import { Component } from "preact";
import { connect } from "react-redux";
import CompleteSummary from "../../components/CompleteSummary";
import Content from "../../components/Content";
import EventMessage from "../../components/EventMessage";
import MoreEvents from "../../components/moreEvents/MoreEvents";
import Page from "../../components/Page";
import Thankyou from "../../components/Thankyou";
import { getDate, getEvent } from "../../state/actions/eventActions";
import { getOrder } from "../../state/actions/orderActions";
import { pageChange } from "../../utils/BrowserUtils";
import Redirect from "./components/Redirect";

class Complete extends Component {
  componentDidMount() {
    const {
      event,
      order,
      getEvent,
      getOrder,
      eventSlug,
      orderId,
      getDate,
      eventDates
    } = this.props;
    if (!event.data && !event.loading) {
      getEvent(eventSlug);
    }
    if (!order.data && !order.orderRequest.loading) {
      getOrder(orderId);
    }
    if (
      !eventDates.selectedDate &&
      order.data &&
      event.data &&
      event.data.datesUseCalendar
    ) {
      getDate(eventSlug, order.data.eventDateId);
    }
  }
  componentWillUpdate(nextProps) {
    const { event, order, eventSlug, getDate, eventDates } = nextProps;
    if (
      event.data &&
      order.data &&
      event.data.datesUseCalendar &&
      !eventDates.selectedDate &&
      !eventDates.loading
    ) {
      getDate(eventSlug, order.data.eventDateId);
    }
    pageChange("Order Complete", event);
  }
  render({ event, order, eventDates }) {
    if (!event.data || !order.data || eventDates.loading || eventDates.error) {
      return;
    }
    if (event.data && event.data.datesUseCalendar && !eventDates.selectedDate) {
      return;
    }
    const background = event.widget ? false : true;
    const hasMoreEvents =
      event &&
      event.data &&
      event.data.moreEvents &&
      event.data.moreEvents.length > 0;

    const showCharity =
      event.data.showCharity &&
      (order.data.totals.donation > 0 ||
        order.data.totals.clientDonation > 0 ||
        order.data.totals.dgrDonation > 0);

    return (
      <div
        style={{
          backgroundColor: "#F9F9FA"
        }}
      >
        <Page transparent={true} background={background} border={false}>
          <Content>
            <div
              style={{
                paddingTop: 40,
                paddingLeft: 14,
                paddingRight: 14
              }}
            >
              {order.data.redirect ? (
                <Redirect redirect={order.data.redirect} />
              ) : null}
              <Thankyou showCharity={showCharity} />
              <CompleteSummary
                order={order}
                event={event}
                date={eventDates.selectedDate}
              />
              <EventMessage event={event.data} order={order.data} />{" "}
            </div>
          </Content>
        </Page>
        {hasMoreEvents && (
          <MoreEvents
            event={event.data}
            title="Similar events you might like"
          />
        )}
      </div>
    );
  }
}
export default connect(
  state => ({
    event: state.event,
    order: state.order,
    eventDates: state.eventDates
  }),
  { getEvent, getOrder, getDate }
)(Complete);



// WEBPACK FOOTER //
// ./routes/complete/Complete.js